module.exports = "https://cdn.dove.it/_next/static/public/assets/services/fotografie_340x200.49671f6d6e616fdd38502fb4e9fd8e57.jpg";